<!-- Header Section -->
<app-header></app-header>

<!-- Main Section -->
<main class="main" style="min-height: 800px;" [ngClass]="removeHeight ? 'height-auto' : '' ">
    <router-outlet></router-outlet>
</main>

<!-- Footer Section -->
<app-footer></app-footer>

<!-- Scroll to Top -->
<button class="scroll-to-top" title="Scroll to Top" [ngClass]="{'animate': scrollToTop}"
    (click)="handler__scrollToTop()">
    <span class="sr-only">Scroll to Top</span>
</button>